import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button/Button";
import SidePanel from "../../components/SidePanel";
import TopBar from "../../components/TopBar";
import Grid from "@mui/material/Grid";
import { useNavigate, useParams } from "react-router-dom";
import { configById, updateConfig } from "../../apis/earnings";

const EditEarning = () => {
  const { config } = useSelector((state: any) => state.earningsReducer);
  const [earningData, setEarningData] = useState(config);
  const navigate = useNavigate();
  let params = useParams();
  const earningId: string | undefined = params?.id;

  //Function to handle the input fields
  const onHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEarningData({ ...earningData, [event.target.name]: event.target.value });
  };

  // Function to update the earning's configs
  const updateEarning = async () => {
    let payload = {
      country_code: earningData.country_code,
      region_code: earningData.region_code,
      normal_driver_comission: earningData.normal_driver_comission,
      premium_driver_comission: earningData.premium_driver_comission,
      scheduler: earningData.scheduler,
      cancelled_ride_comission: earningData.cancelled_ride_comission,
      community_driver_comission_within_six_months:
        earningData.community_driver_comission_within_six_months,
      community_driver_comission_after_six_months:
        earningData.community_driver_comission_after_six_months,
      ride_cancellation_charges: earningData.ride_cancellation_charges,
    };
    let res = await updateConfig(earningId, payload);
    if (res?.status) {
      navigate("/earnings-and-management");
    }
  };

  // Function to fetch and update the earning configs
  const getConfigById = async (id: any) => {
    const data = await configById(id);
    setEarningData(data);
  };

  useEffect(() => {
    const id = earningId !== undefined ? earningId : "";
    getConfigById(id);
    console.log("config data " + JSON.stringify(config));
  }, []);

  return (
    <Box className="mainContainer">
      <Box className="sidePanelContainer">
        <SidePanel isOpen={true} onClose={() => { }} />
      </Box>
      <Box className="dashboardContainer">
        <TopBar />
        <Box style={{ width: "100%", padding: "20px", marginTop: "5%" }}>
          <Box>
            <div
              style={{
                marginBottom: "20px",
              }}
            >
              <Typography style={{ fontWeight: 700, fontSize: 18, marginBottom: "20px" }}>
                Update Earning
              </Typography>

              <Box
                sx={{
                  bgcolor: "background.paper",
                  boxShadow: 24,
                  p: 4,
                }}
              >
                <Box
                  style={{
                    padding: "20px",
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={4} md={6}>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        placeholder="When drivers get paid"
                        label="When drivers get paid?"
                        name="scheduler"
                        variant="outlined"
                        value={earningData?.scheduler}
                        type="number"
                        style={{ marginBottom: "10px", width: "100%" }}
                        onChange={onHandleChange}
                      />
                    </Grid>
                    <Grid item xs={4} md={6}>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        placeholder="Normal Driver Comission"
                        label="Normal Driver Comission"
                        name="normal_driver_comission"
                        variant="outlined"
                        value={earningData?.normal_driver_comission}
                        type="number"
                        style={{ marginBottom: "10px", width: "100%" }}
                        InputLabelProps={{ shrink: true }}
                        onChange={onHandleChange}
                      />
                    </Grid>
                    <Grid item xs={4} md={6}>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        placeholder="Premium Driver Comission"
                        label="Premium Driver Comission"
                        name="premium_driver_comission"
                        variant="outlined"
                        value={earningData?.premium_driver_comission}
                        type="number"
                        style={{ marginBottom: "10px", width: "100%" }}
                        InputLabelProps={{ shrink: true }}
                        onChange={onHandleChange}
                      />
                    </Grid>
                    <Grid item xs={4} md={6}>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        placeholder="Community Driver Comission Within Six Months"
                        label="Community Driver Comission Within Six Months"
                        name="community_driver_comission_within_six_months"
                        variant="outlined"
                        value={earningData?.community_driver_comission_within_six_months}
                        type="number"
                        style={{ marginBottom: "10px", width: "100%" }}
                        InputLabelProps={{ shrink: true }}
                        onChange={onHandleChange}
                      />
                    </Grid>
                    <Grid item xs={4} md={6}>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        placeholder="Community Driver Comission After Six Months"
                        label="Community Driver Comission After Six Months"
                        name="community_driver_comission_after_six_months"
                        variant="outlined"
                        value={earningData?.community_driver_comission_after_six_months}
                        type="number"
                        style={{ marginBottom: "10px", width: "100%" }}
                        InputLabelProps={{ shrink: true }}
                        onChange={onHandleChange}
                      />
                    </Grid>
                    <Grid item xs={4} md={6}>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        placeholder="Cancelled Ride Comission"
                        label="Cancelled Ride Comission"
                        name="cancelled_ride_comission"
                        variant="outlined"
                        value={earningData?.cancelled_ride_comission}
                        type="number"
                        style={{ marginBottom: "10px", width: "100%" }}
                        InputLabelProps={{ shrink: true }}
                        onChange={onHandleChange}
                      />
                    </Grid>
                    <Grid item xs={4} md={6}>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        placeholder="Ride Cancellation Charges"
                        label="Ride Cancellation Charges"
                        name="ride_cancellation_charges"
                        variant="outlined"
                        value={earningData?.ride_cancellation_charges}
                        type="number"
                        style={{ marginBottom: "10px", width: "100%" }}
                        InputLabelProps={{ shrink: true }}
                        onChange={onHandleChange}
                      />
                    </Grid>
                  </Grid>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    alignItem: "center",
                  }}
                >
                  <Button
                    style={{ marginRight: "4px", backgroundColor: "gray" }}
                    variant="contained"
                    onClick={() => {
                      navigate("/earnings-and-management");
                    }}
                  >
                    Cancel
                  </Button>
                  <Button variant="contained" onClick={updateEarning}>
                    Update
                  </Button>
                </Box>
              </Box>
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default EditEarning;
